import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';

export const userSettingsMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'user-settings',
  component: lazyRouteComponent(() => import('./UserSettingsView')),
});
